import { useMutation, useQueryClient } from '@tanstack/react-query';
import { cancelRequestedPlan } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useCancelRequestPlan() {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: cancelRequestedPlan,
    mutationKey: ['cancelRequestedPlan'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        return toastEmitter('error', responseData?.error?.message);
      }
      queryclient.invalidateQueries(['getRequestedPlan']);
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
